export default "__VITE_ASSET__d88ab650__$_?nuxt_component=async__"